import { render, staticRenderFns } from "./StarModel.vue?vue&type=template&id=765bbcf6"
import script from "./StarModel.vue?vue&type=script&lang=js"
export * from "./StarModel.vue?vue&type=script&lang=js"
import style0 from "./StarModel.vue?vue&type=style&index=0&id=765bbcf6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports